module.exports = __webpack_public_path__ + "img/logo.e0bc8e46.svg";